var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_2191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7.35059C18.32 7.35059 13.46 12.0456 12.7805 18.0381C11.4735 18.2487 10.2477 18.8088 9.23293 19.659C8.21816 20.5093 7.45216 21.6181 7.016 22.8681C3.326 23.9316 0.5 27.2226 0.5 31.3506C0.5 36.3366 4.514 40.3506 9.5 40.3506H39.5C44.486 40.3506 48.5 36.3366 48.5 31.3506C48.5 28.7106 47.2175 26.3466 45.359 24.6936C45.011 19.4226 40.8065 15.2166 35.516 14.9436C33.71 10.5501 29.567 7.35059 24.5 7.35059ZM24.5 10.3506C28.643 10.3506 31.955 13.0056 33.125 16.7706L33.455 17.8506H35C39.1325 17.8506 42.5 21.2181 42.5 25.3506V26.1006L43.109 26.5701C43.844 27.1334 44.4412 27.8565 44.8555 28.6848C45.2697 29.513 45.4901 30.4246 45.5 31.3506C45.5 34.7646 42.914 37.3506 39.5 37.3506H9.5C6.086 37.3506 3.5 34.7646 3.5 31.3506C3.5 28.3206 5.675 25.9686 8.42 25.4916L9.4055 25.3041L9.593 24.3171C10.043 22.2966 11.834 20.8506 14 20.8506H15.5V19.3506C15.5 14.2956 19.445 10.3506 24.5 10.3506ZM24.5 18.7416L23.42 19.7721L17.42 25.7721L19.58 27.9321L23 24.5061V34.3506H26V24.5061L29.42 27.9291L31.58 25.7691L25.58 19.7691L24.5 18.7416Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_2191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.62793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.1654332e6080bf0fee56a740edfba396.svg";
export { ForwardRef as ReactComponent };